import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
  booleanAttribute,
} from "@angular/core";

@Directive({
  selector: "[file-drop-zone]",
  standalone: true,
})
export class FileDropDirective {
  @Input({ transform: booleanAttribute }) disabled: boolean  = false;

  @Output() onFileOver = new EventEmitter<void>();
  @Output() onFileLeave = new EventEmitter<void>();
  @Output() onFileDrop = new EventEmitter<FileSystemEntry[]>();

  @HostListener("dragover", ["$event"])
  onDragOver(event: DragEvent) {
    if (this.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.onFileOver.emit();
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event: DragEvent) {
    if (this.disabled) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.onFileLeave.emit();
  }

  @HostListener("drop", ["$event"])
  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (this.disabled) {
      return;
    }

    this.onFileLeave.emit();
    const entries = this.getDroppedEntries(event.dataTransfer);
    this.onFileDrop.emit(entries);
  }

  private getDroppedEntries(dataTransfer: DataTransfer | null) {
    if (!dataTransfer) {
      return [];
    }

    const entries = Array.from(dataTransfer.items)
      .map((item) => item.webkitGetAsEntry())
      .filter((entry) => entry !== null)

    return entries;
  }
}
